/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const createNumberValidation = (fieldName) =>
  Yup.number()
    .typeError(`Invalid data. '${fieldName}' must be a number`)
    .nullable(true)
    .test('is-number', `Invalid data. '${fieldName}' must be a number`, function (value) {
      return (value === null || value === undefined || !isNaN(value)) || this.createError({ message: `Invalid data. '${fieldName}' must be a number` });
    });


const TODIS_LIWWPORTS_SCHEMA = Yup.object().shape({
  //general section Rules:
  nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
  addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
  contactNum: Yup.string()
    .transform((originalValue) => {
      // Si el valor comienza con '+', eliminamos ese símbolo
      return typeof originalValue == 'string' ? originalValue.replace(/^\+/, '') : originalValue;
    })
    .nullable(true)
    .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
      // Permitir números, espacios, y la presencia de '+'
      const isValid = /^[0-9+\s]+$/.test(value) || value == null;

      if (!isValid) {
        throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
      }

      return true;
    }),

  contactEmail: Yup.string("Email")
    .transform((originalValue) => {
      // Realizar transformaciones si es necesario
      return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
    })
    .nullable(true)
    .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
      // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
      if (value === null || value === undefined) {
        return true;
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      // Verificar si es una cadena antes de intentar dividirla
      if (typeof value === 'string') {
        const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

        for (const email of emails) {
          if (!emailRegex.test(email.trim())) {
            throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
          }
        }
      }

      return true;
    }),
  countryCode: Yup.string("Country Code").nullable(true),
  tentTCategory: Yup.string("tent category is alphanumeric").nullable(true),
  nodeNameval: Yup.string("End Node Name is alphanumeric").nullable(true),
  /*   dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true), */
  dateValidFor: Yup.string("Valid for is a Year").nullable(true),
  remarks: Yup.string("remarks").nullable(true),

  iwwPortsLivePmDescDTO: Yup.object().shape({
    projectName: Yup.string('Value should be a text').nullable(true),
    typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
    length: Yup.string('Value should be a text').nullable(true),
    totalCostCapex: createNumberValidation('Total Cost (CAPEX) (Euro)'),
    estiImpDeadline: Yup.date('Value should be date').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwPortsLivePmEligiTentDTO: Yup.object().shape({
    cemtConn: Yup.boolean().nullable(true),
    cleanFuelsAvail: Yup.boolean().nullable(true),
    terminalAvail: Yup.boolean().nullable(true),
    risDeployment: Yup.boolean().nullable(true),
    befRailConn: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),
    intermodalUnitsHandling: Yup.boolean().nullable(true),
    accommodate740mTrains: Yup.boolean().nullable(true),
    environmentalPerformanceImprovementEquipment: Yup.boolean().nullable(true),
    alternativeFuelsAvailability: Yup.boolean().nullable(true),
  }),
  iwwPortsLivePmIndicatorsDTO: Yup.object().shape({
    siAnnTraffDemGro: Yup.number('Value should be number').nullable(true),
    siModalTrans: Yup.number('Value should be number').nullable(true),
    siAnnTraffAcciRateRed: Yup.number('Value should be number').nullable(true),
    eiEirr: Yup.number('Value should be number').nullable(true),
    eiNpv: Yup.number('Value should be number').nullable(true),
    eiSdr: Yup.number('Value should be number').nullable(true),
    eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
    eiProjConstCost: Yup.number('Value should be number').nullable(true),
    eiTotalProjCost: Yup.number('Value should be number').nullable(true),
    fiFirr: Yup.number('Value should be number').nullable(true),
    fiFnpv: Yup.number('Value should be number').nullable(true),
    fiFdr: Yup.number('Value should be number').nullable(true),
    fiWacc: Yup.number('Value should be number').nullable(true),
    fiFirtsYearProf: Yup.date("Valid to is a Date").nullable(true),
    fiDscr: Yup.number('Value should be number').nullable(true),
    eniCo2Ems: Yup.number('Value should be number').nullable(true),
    eniNoxEms: Yup.number('Value should be number').nullable(true),
    eniSo2Ems: Yup.number('Value should be number').nullable(true),
    eniNmhcEms: Yup.number('Value should be number').nullable(true),
    eniPpm: Yup.number('Value should be number').nullable(true),
    eniNoiseLevel: Yup.number('Value should be number').nullable(true),
    eniCliChangeRes: Yup.number('Value should be number').nullable(true),
    eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwPortsLivePmPiDTO: Yup.object().shape({
    forecastConstPeriod: Yup.number('Value should be number').nullable(true),
    actualConstPeriod: Yup.number('Value should be number').nullable(true),
    forecastCapex: Yup.number('Value should be number').nullable(true),
    actualCapex: Yup.number('Value should be number').nullable(true),
    forecastOpex: Yup.number('Value should be number').nullable(true),
    actualOpex: Yup.number('Value should be number').nullable(true),
    forecastMaintCost: Yup.number('Value should be number').nullable(true),
    actualMaintCost: Yup.number('Value should be number').nullable(true),
    interestDuringConst: Yup.number('Value should be number').nullable(true),
    ebitda: Yup.number('Value should be number').nullable(true),
    forecastRevenue: Yup.number('Value should be number').nullable(true),
    actualRevenue: Yup.number('Value should be number').nullable(true),
    forecastTrainTraffic: Yup.number('Value should be number').nullable(true),
    actualTrainTraffic: Yup.number('Value should be number').nullable(true),
    forecastPassTraffic: Yup.number('Value should be number').nullable(true),
    actualPassTraffic: Yup.number('Value should be number').nullable(true),
    forecastFreightTn: Yup.number('Value should be number').nullable(true),
    actualFreightTn: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  }),
  iwwPortsLivePmStatusDTO: Yup.object().shape({
    implemented: Yup.string('Value should be a text').nullable(true),
    ongoingProjFs: Yup.string('Value should be a text').nullable(true),
    matureProjFs: Yup.string('Value should be a text').nullable(true),
    projUnderPrep: Yup.string('Value should be a text').nullable(true),
    projStatusDesc: Yup.string('Value should be a text').nullable(true),
    projFundNatBudg: Yup.number()
      .typeError("Invalid data. 'National Budget (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'National Budget (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'National Budget (Euro)\' must be a number' });
        }
        return true;
      }),
    projFundNatBudgAllo: Yup.boolean().nullable(true),
    projFundWb: Yup.number()
      .typeError("Invalid data. 'World Bank (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'World Bank (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'World Bank (Euro)\' must be a number' });
        }
        return true;
      }),
    projFundWbAllo: Yup.boolean().nullable(true),
    projFundEbrd: Yup.number()
      .typeError("Invalid data. 'EBRD (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'EBRD (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'EBRD (Euro)\' must be a number' });
        }
        return true;
      }),
    projFundEbrdAllo: Yup.boolean().nullable(true),
    projFundEib: Yup.number()
      .typeError("Invalid data. 'EIB (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'EIB (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'EIB (Euro)\' must be a number' });
        }
        return true;
      }),
    projFundEibAllo: Yup.boolean().nullable(true),
    otherIfi: Yup.number()
      .typeError("Invalid data. 'Other IFI (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Other IFI (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'Other IFI (Euro)\' must be a number' });
        }
        return true;
      }),
    otherIfiSpec: Yup.string('Value should be a text').nullable(true),
    otherIfiAllo: Yup.boolean().nullable(true),
    concession: Yup.number()
      .typeError("Invalid data. 'Concessions (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Concessions (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'Concessions (Euro)\' must be a number' });
        }
        return true;
      }),
    concessionSpec: Yup.string('Value should be a text').nullable(true),
    concessionAllo: Yup.boolean().nullable(true),
    euFund: Yup.number()
      .typeError("Invalid data. 'EU Fund (Euro)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'EU Fund (Euro)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'EU Fund (Euro)\' must be a number' });
        }
        return true;
      }),
    euFundSpec: Yup.string('Value should be a text').nullable(true),
    euFundAllo: Yup.boolean().nullable(true),
    otherFund: Yup.number()
      .typeError("Invalid data. 'Other funding source (name)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Other funding source (name)\' must be a number', function (value) {
        if (isNaN(value) && value !== null && value !== undefined && value !== '') {
          throw this.createError({ message: 'Invalid data. \'Other funding source (name)\' must be a number' });
        }
        return true;
      }),
    otherFundSpec: Yup.string('Value should be a text').nullable(true),
    otherFundAllo: Yup.boolean().nullable(true),
    preFeasiStudy: Yup.boolean().nullable(true),
    feasiStudy: Yup.boolean().nullable(true),
    conceptDesign: Yup.boolean().nullable(true),
    prelimDesign: Yup.boolean().nullable(true),
    detailDesign: Yup.boolean().nullable(true),
    environImpactAssess: Yup.boolean().nullable(true),
    projFeasiStudyTitley: Yup.string('Value should be a text').nullable(true),
    projFeasiStudyPrepBy: Yup.string('Value should be a text').nullable(true),
    projFeasiStudySupervBy: Yup.string('Value should be a text').nullable(true),
    conceptDesignTitle: Yup.string('Value should be a text').nullable(true),
    conceptDesignPrepBy: Yup.string('Value should be a text').nullable(true),
    conceptDesignSupervBy: Yup.string('Value should be a text').nullable(true),
    prelimDesignTitle: Yup.string('Value should be a text').nullable(true),
    prelimDesignPrepBy: Yup.string('Value should be a text').nullable(true),
    prelimDesignSupervBy: Yup.string('Value should be a text').nullable(true),
    detailDesignTitle: Yup.string('Value should be a text').nullable(true),
    detailDesignPrepBy: Yup.string('Value should be a text').nullable(true),
    detailDesignSupervBy: Yup.string('Value should be a text').nullable(true),
    environImpactAssessTitle: Yup.string('Value should be a text').nullable(true),
    environImpactAssessPrepBy: Yup.string('Value should be a text').nullable(true),
    environImpactAssessSupervBy: Yup.string('Value should be a text').nullable(true),
    tenderStartDateInitFore: Yup.date("Valid to is a Date").nullable(true),
    tenderStartDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
    tenderStartDateActual: Yup.date("Valid to is a Date").nullable(true),
    designCompDateFore: Yup.date("Valid to is a Date").nullable(true),
    designCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
    designCompDateActual: Yup.date("Valid to is a Date").nullable(true),
    projCompDateFore: Yup.date("Valid to is a Date").nullable(true),
    projCompDateCurrEst: Yup.date("Valid to is a Date").nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwPortsLivePmTentcompDTO: Yup.object().shape({
    befRailConn: Yup.boolean().nullable(true),
    aftRailConn: Yup.boolean().nullable(true),
    befCmtConn: Yup.boolean().nullable(true),
    aftCmtConn: Yup.boolean().nullable(true),
    befCleanFuels: Yup.string('Value should be a text').nullable(true),
    aftCleanFuels: Yup.boolean().nullable(true),
    befTerminalAvail: Yup.boolean().nullable(true),
    aftTerminalAvail: Yup.boolean().nullable(true),
    befRisDeploy: Yup.boolean().nullable(true),
    aftRisDeploy: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),
    befAccommodate740mTrains: Yup.boolean().nullable(true),
    aftAccommodate740mTrains: Yup.boolean().nullable(true),
    befEnvironmentalPerformanceImprovementEquipment: Yup.boolean().nullable(true),
    aftEnvironmentalPerformanceImprovementEquipment: Yup.boolean().nullable(true),
    befAlternativeFuelsAvailability: Yup.boolean().nullable(true),
    aftAlternativeFuelsAvailability: Yup.boolean().nullable(true),
  })
});

const LIWWPORTS_INIT = {
  dateValidTo: "",
  dateValidFrom: "",
  dateValidFor: "",
  tentTCategory: "",
  nameResp: "",
  addressResp: "",
  contactPer: "",
  contactPos: "",
  contactNum: 0,
  contactEmail: "",
  countryCode: "",
  nodeNameval: "",
  remarks: "",
  iwwPortsLivePmDescDTO: {
    projectName: "",
    typeForeseenInterven: "",
    length: "",
    totalCostCapex: "",
    estiImpDeadline: "",
    remarks: ""
  },
  iwwPortsLivePmEligiTentDTO: {
    cemtConn: false,
    cleanFuelsAvail: false,
    terminalAvail: false,
    risDeployment: false,
    befRailConn: false,
    remarks: "",
    intermodalUnitsHandling: false,
    accommodate740mTrains: false,
    environmentalPerformanceImprovementEquipment: false,
    alternativeFuelsAvailability: false
  },
  iwwPortsLivePmIndicatorsDTO: {
    siAnnTraffDemGro: "",
    siModalTrans: "",
    siAnnTraffAcciRateRed: "",
    eiEirr: "",
    eiNpv: "",
    eiSdr: "",
    eiProjPlanDesCost: "",
    eiProjConstCost: "",
    eiTotalProjCost: "",
    fiFirr: "",
    fiFnpv: "",
    fiFdr: "",
    fiWacc: "",
    fiFirtsYearProf: "",
    fiDscr: "",
    eniCo2Ems: "",
    eniNoxEms: "",
    eniSo2Ems: "",
    eniNmhcEms: "",
    eniPpm: "",
    eniNoiseLevel: "",
    eniCliChangeRes: "",
    eniProteNatuaAff: "",
    remarks: ""
  },
  iwwPortsLivePmPiDTO: {
    forecastConstPeriod: "",
    actualConstPeriod: "",
    forecastCapex: "",
    actualCapex: "",
    forecastOpex: "",
    actualOpex: "",
    forecastMaintCost: "",
    actualMaintCost: "",
    interestDuringConst: "",
    ebitda: "",
    forecastRevenue: "",
    actualRevenue: "",
    forecastTrainTraffic: "",
    actualTrainTraffic: "",
    forecastPassTraffic: "",
    actualPassTraffic: "",
    forecastFreightTn: "",
    actualFreightTn: "",
    remarks: ""
  },
  iwwPortsLivePmStatusDTO: {
    implemented: "",
    ongoingProjFs: "",
    matureProjFs: "",
    projUnderPrep: "",
    projStatusDesc: "",
    projFundNatBudg: "",
    projFundNatBudgAllo: false,
    projFundWb: "",
    projFundWbAllo: false,
    projFundEbrd: "",
    projFundEbrdAllo: false,
    projFundEib: "",
    projFundEibAllo: false,
    otherIfi: "",
    otherIfiSpec: "",
    otherIfiAllo: false,
    concession: "",
    concessionSpec: "",
    concessionAllo: false,
    euFund: "",
    euFundSpec: "",
    euFundAllo: false,
    otherFund: "",
    otherFundSpec: "",
    otherFundAllo: false,
    preFeasiStudy: "",
    feasiStudy: "",
    conceptDesign: "",
    prelimDesign: "",
    detailDesign: "",
    environImpactAssess: "",
    projFeasiStudyTitle: "",
    projFeasiStudyPrepBy: "",
    projFeasiStudySupervBy: "",
    conceptDesignTitle: "",
    conceptDesignPrepBy: "",
    conceptDesignSupervBy: "",
    prelimDesignTitle: "",
    prelimDesignPrepBy: "",
    prelimDesignSupervBy: "",
    detailDesignTitle: "",
    detailDesignPrepBy: "",
    detailDesignSupervBy: "",
    environImpactAssessTitle: "",
    environImpactAssessPrepBy: "",
    environImpactAssessSupervBy: "",
    tenderStartDateInitFore: "",
    tenderStartDateCurrEst: "",
    tenderStartDateActual: "",
    designCompDateFore: "",
    designCompDateCurrEst: "",
    designCompDateActual: "",
    projCompDateFore: "",
    projCompDateCurrEst: "",
    remarks: ""
  },
  iwwPortsLivePmTentcompDTO: {
    befRailConn: false,
    aftRailConn: false,
    befCmtConn: false,
    aftCmtConn: false,
    befCleanFuels: false,
    aftCleanFuels: false,
    befTerminalAvail: false,
    aftTerminalAvail: false,
    befRisDeploy: false,
    aftRisDeploy: false,
    remarks: "",
    befIntermodalUnitsHandling: false,
    aftIntermodalUnitsHandling: false,
    befAccommodate740mTrains: false,
    aftAccommodate740mTrains: false,
    befEnvironmentalPerformanceImprovementEquipment: false,
    aftEnvironmentalPerformanceImprovementEquipment: false,
    befAlternativeFuelsAvailability: false,
    aftAlternativeFuelsAvailability: false
  }
}

export { TODIS_LIWWPORTS_SCHEMA, LIWWPORTS_INIT };